(function($, undefined) {
	'use strict';
	var formValidator;
	var locationsUtils;
	
	var init = function() {
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;
		
		$('#add-new-location-contact-form-btn').on('click', onAddNewContactToLocation);
		$('.submit-location-contacts-form').on('click', onSaveLocationContacts);
		$('#current-location-contacts-list .location-form-editable-list-item__btn_edit').on('click', onEditLocationContact);
		$('.location-contact-edit-form-btns .cancel-edit-location-contact-btn').on('click', onCancelLocationContactEdit);
		$('.location-contact-edit-form-btns .save-edit-location-contact-btn').on('click', onSaveLocationContactEdit);
	};
	
	var onAddNewContactToLocation = function() {
		var form = $('.add-location-contact-form');
		var contactsList = $('#current-location-contacts-list');
		var contactsListItems = $('.location-form-editable-list-item:not(.template)', contactsList);
		
		formValidator.validateForm(form);
		if (!form.hasClass('has-error')) {
			var hasRole = $('[name=role]', form).val().length > 0;
			
			var currentContactJson = {
				"lastName": $('[name=lastName]', form).val(),
				"firstName": $('[name=firstName]', form).val(),
				"company": $('[name=company]', form).val(),
				"role": $('[name=role]', form).val(),
				"roleText": hasRole ? $('[name=role] option:selected').text() : "",
				"phone": $('[name=phone]', form).val(),
				"email": $('[name=email]', form).val(),
			};
			
			var index =	($('.location-form-editable-list-item:not(.template)[data-item-id]', contactsList).get().reduce((prev, curr) => Math.max(curr.dataset.itemId, prev), 1)) + 1;
			var newItem = $('.location-form-editable-list-item.template', contactsList).clone(true);
			$('.name', newItem).text(currentContactJson.firstName + " " + currentContactJson.lastName);
			$('.role', newItem).text(currentContactJson.roleText); 
			$('.phone', newItem).text(currentContactJson.phone);
			$('.email', newItem).text(currentContactJson.email);
			newItem.removeClass('template');
			newItem.attr('data-json', JSON.stringify(currentContactJson));
			newItem.attr('data-id', `${newItem.attr('data-id')}${index}`);
			newItem.find('.delete-popup-btn').attr('data-item-id', index);
			if (hasRole) {
				$('.name-role-sep', newItem).show();
			} else {
				$('.name-role-sep', newItem).hide();
			}
			contactsList.append(newItem);
			$('input, select', form).val("");
		}
	};
	
	var onSaveLocationContacts = function() {
		var form = $('.location-form-content');
		var contactsList = $('#current-location-contacts-list');
		var contactsListItems = $('.location-form-editable-list-item:not(.template)', contactsList);
		
		var contactsArray = [];
		contactsListItems.each((i, el) => {
			contactsArray.push(JSON.parse($(el).attr('data-json')));
		});
		const data = {
			id: form.find('[name="id"]').val(),
			field1: 'location',
			field11: JSON.stringify(contactsArray)
		};
		locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
			if (id != null) {
				form.find('[name="id"]').val(id);
				locationsUtils.showMessage(form, '_success');
				form.find('.add-location-info__client_hidden')
					.removeClass('add-location-info__client_hidden')
					.find('input')
					.val(id);
			} else {
				locationsUtils.showMessage(form, '_server');
			}
			locationsUtils.removeOverlay();
		});
	};
	
	var onEditLocationContact = function() {
		var btn = $(this);
		var item = btn.closest('.location-form-editable-list-item');
		var json = JSON.parse(item.attr('data-json'));
		var form = $('.add-location-contact-form');
		
		$('[name=firstName]', form).val(json.firstName);
		$('[name=lastName]', form).val(json.lastName);
		$('[name=company]', form).val(json.company);
		$('[name=role]', form).val(json.role);
		$('[name=phone]', form).val(json.phone);
		$('[name=email]', form).val(json.email);
		
		$('.location-contact-edit-form-btns .save-edit-location-contact-btn').attr('data-item-index', item.index());
		$('.location-contact-edit-form-btns', form).show();
	};
	
	var onCancelLocationContactEdit = function() {
		var form = $('.add-location-contact-form');
		$('input, select', form).val("");
		$('.location-contact-edit-form-btns .save-edit-location-contact-btn').removeAttr('data-item-index');
		$('.location-contact-edit-form-btns', form).hide();
	};
	
	var onSaveLocationContactEdit = function() {	
		var btn = $(this);	
		var form = $('.add-location-contact-form');
		var contactsList = $('#current-location-contacts-list');
		var contactsListItems = $('.location-form-editable-list-item:not(.template)', contactsList);
		
		formValidator.validateForm(form);
		if (!form.hasClass('has-error')) {
			var hasRole = $('[name=role]', form).val().length > 0;
			
			var currentContactJson = {
				"lastName": $('[name=lastName]', form).val(),
				"firstName": $('[name=firstName]', form).val(),
				"company": $('[name=company]', form).val(),
				"role": $('[name=role]', form).val(),
				"roleText": hasRole ? $('[name=role] option:selected').text() : "",
				"phone": $('[name=phone]', form).val(),
				"email": $('[name=email]', form).val(),
			};
			
			var item = $('.location-form-editable-list-item', contactsList).eq(btn.attr('data-item-index'));
			$('.name', item).text(currentContactJson.firstName + " " + currentContactJson.lastName);
			$('.role', item).text(currentContactJson.roleText); 
			$('.phone', item).text(currentContactJson.phone);
			$('.email', item).text(currentContactJson.email);
			item.attr('data-json', JSON.stringify(currentContactJson));
			if (hasRole) {
				$('.name-role-sep', item).show();
			} else {
				$('.name-role-sep', item).hide();
			}
			$('input, select', form).val("");
			$('.location-contact-edit-form-btns', form).hide();	
		}
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
